/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Light_Green_Vole_WeepInputs */

const en_light_green_vole_weep = /** @type {(inputs: Light_Green_Vole_WeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Survey`)
};

const de_light_green_vole_weep = /** @type {(inputs: Light_Green_Vole_WeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Befragung`)
};

/**
* | output |
* | --- |
* | "Survey" |
*
* @param {Light_Green_Vole_WeepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const light_green_vole_weep = /** @type {((inputs?: Light_Green_Vole_WeepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Light_Green_Vole_WeepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_light_green_vole_weep(inputs)
	return de_light_green_vole_weep(inputs)
});